








































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import {
  OnlineBookingSlotGeneratorFormModel,
  ScheduleSeason,
  SlotDuration,
} from '@bookings/interfaces/schedule';
import BpcScheduleOnlineBookingSlotGrid from './schedule-online-booking-slot-grid.vue';
import { useScheduleService } from '@bookings/services/schedule-service';
import { onlineBookingSlotsFields } from '@/config/schedule-config';

@Component({
  name: 'bpc-schedule-slots-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcEntitySelect,
    BpcSection,
    BpcScheduleOnlineBookingSlotGrid,
  },
})
export default class ScheduleSlotsForm extends Vue {
  @Prop(Object) readonly value: ScheduleSeason;

  get formModel() {
    return this.value;
  }

  set formModel(value: ScheduleSeason) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return onlineBookingSlotsFields;
  }

  get addNewDurationLabel(): string {
    if (!this.formModel.online_booking_slots || this.formModel.online_booking_slots.length === 0) {
      return `+ ${this.$t('bookings.slot.add_new_duration_label')}`;
    } else {
      return '+';
    }
  }

  get addNewDurationVariant(): string {
    if (!this.formModel.online_booking_slots || this.formModel.online_booking_slots.length === 0) {
      return 'primary';
    } else {
      return 'link';
    }
  }

  loading = false;

  async addNewSlots(generatorFormModel: OnlineBookingSlotGeneratorFormModel) {
    console.log('addNewSlots', generatorFormModel);
    const srv = useScheduleService();
    this.formModel.online_booking_slots = await srv.addNewSlots(
      this.formModel.online_booking_slots || [],
      generatorFormModel,
    );
  }

  async addNewSlotDuration(duration: number) {
    const srv = useScheduleService();
    this.formModel.online_booking_slots = await srv.addNewSlotDuration(
      this.formModel.online_booking_slots || [],
      duration as SlotDuration,
    );
  }

  async removeSlotDuration(duration: number) {
    const srv = useScheduleService();
    this.formModel.online_booking_slots = await srv.removeSlotDuration(
      this.formModel.online_booking_slots || [],
      duration as SlotDuration,
    );
  }
}
